var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.537 9.114V7.889h8.925v1.225H1.537zm9.013-2.1h-9.1a.788.788 0 00-.788.787v1.4a.788.788 0 00.788.788h9.1a.788.788 0 00.787-.788v-1.4a.788.788 0 00-.787-.787zm-9.013-2.1V.889h6.125v4.025H1.537zm7-.254V5a.788.788 0 01-.787.788h-6.3A.788.788 0 01.662 5v-4.2c0-.435.353-.787.788-.787h6.3c.434 0 .787.352.787.787v.342l1.66-.83a.788.788 0 011.14.705v3.767a.788.788 0 01-1.14.704l-1.66-.83zm0-.979l1.925.963V1.158l-1.925.963v1.56z",
    fill: "#FFF"
  })));
}
export default __webpack_public_path__ + "static/media_white.5b89a1e1.svg";
export { SvgMediaWhite as ReactComponent };